import {
    feedbackQuestionText,
    noText,
    yesText,
    yesAriaLabelText,
    noAriaLabelText,
} from './FeedbackContainerOld.locstring.json';
import { resolvedFeedbackTooltip } from '../strings.locstring.json';
import { ActionButton } from '@fluentui/react/lib/Button';
import { observer } from 'mobx-react-lite';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import loc from 'owa-localize';
import { getPaletteAsRawColors } from 'owa-theme';
import * as React from 'react';

const styles = require('./RelatedContentCommonStyles.scss');

export interface FeedbackContainerOldProps {
    colorScheme: ColorScheme;
    onUsefulButtonClicked: () => void;
    onNotUsefulButtonClicked: () => void;
}

export interface FeedbackContainerOldStateProps {
    checkedOption: FeedbackType;
}

enum FeedbackType {
    None = 0,
    Useful = 1,
    NotUseful = 2,
}

export default observer(function FeedbackContainerOld(props: FeedbackContainerOldProps) {
    const [checkedOption, setCheckedOption] = React.useState<FeedbackType>(FeedbackType.None);
    const renderFeedbackButton = (feedbackType: FeedbackType): JSX.Element => {
        const displayText = feedbackType === FeedbackType.Useful ? loc(yesText) : loc(noText);
        const ariaLabelText =
            feedbackType === FeedbackType.Useful ? loc(yesAriaLabelText) : loc(noAriaLabelText);
        const onButtonClicked =
            feedbackType === FeedbackType.Useful ? onClickUsefulButton : onClickNotUsefulButton;
        // calculate root text style
        const textColor = getOptimalTextColorString(
            getPaletteAsRawColors().neutralLighterAlt,
            props.colorScheme,
            props.colorScheme.calDarkAlt
        );
        const textHoverPressColor = getOptimalTextColorString(
            getPaletteAsRawColors().neutralLighterAlt,
            props.colorScheme,
            props.colorScheme.calDarker
        );
        return (
            <ActionButton
                text={displayText}
                aria-label={ariaLabelText}
                styles={{
                    root: {
                        fontSize: '12',
                        height: '100%',
                        marginRight: '-5px',
                        paddingTop: '1px',
                        color: textColor,
                    },
                    labelHovered: {
                        color: textHoverPressColor,
                    },
                }}
                onClick={onButtonClicked}
            />
        );
    };
    const onClickUsefulButton = (evt: any) => {
        evt.stopPropagation();
        setCheckedOption(FeedbackType.Useful);
        props.onUsefulButtonClicked();
    };
    const onClickNotUsefulButton = (evt: any) => {
        evt.stopPropagation();
        setCheckedOption(FeedbackType.NotUseful);
        props.onNotUsefulButtonClicked();
    };
    const hasFeedbackButtonClicked =
        checkedOption === FeedbackType.Useful || checkedOption === FeedbackType.NotUseful;
    return (
        <div className={styles.FeedbackContainerOld}>
            {hasFeedbackButtonClicked ? (
                <>{loc(resolvedFeedbackTooltip)}</>
            ) : (
                <>
                    {loc(feedbackQuestionText)}
                    {renderFeedbackButton(FeedbackType.Useful)}
                    {renderFeedbackButton(FeedbackType.NotUseful)}
                </>
            )}
        </div>
    );
});
